<template>
  <div v-if="show" class="bh-modal">
    <div class="bh-overlay" @click="$emit('close')" />

    <div class="bh-dialog" role="dialog" aria-modal="true">

      <!-- BANNER -->
      <div class="vp-banner">
        <img
          src="../assets/images/activate_banner.png"
          alt="Vision+ Banner"
        />
      </div>

      <!-- CONTENT -->
      <div class="vp-content">
        <div class="vp-title">
          Akun Anda Sudah Tidak Aktif
        </div>

        <div class="vp-desc">
          Saat ini akun anda sedang dalam posisi tidak aktif. Aktifkan kembali akun Anda sekarang untuk menikmati benefit yang tersedia.
        </div>

        <!-- ACTION -->
        <button
          class="vp-btn-primary"
          @click="lanjutkan"
          :disabled="loading"
        >
          <span v-if="loading" class="loader"></span>
          <span>{{ loading ? 'Memproses...' : 'Masuk dan Aktifkan Akun' }}</span>
        </button>
        <button class="vp-btn-secondary" @click="$emit('close')">
          Keluar
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ActivateAccountModal',
  data() {
    return {
      loading: false
    }
  },
  props: {
    show: { type: Boolean, default: false },
    phone: { type: String, default: '' }
  },
  watch: {
    show (val) {
      if (val) document.addEventListener('keydown', this.onKeydown)
      else document.removeEventListener('keydown', this.onKeydown)
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown (e) {
      if (e.key === 'Escape') this.$emit('close')
    },
    async lanjutkan() {
      if (this.loading) return

      this.loading = true
      try {
        const form = new FormData()
        form.append('phone_number', this.phone)

        const res = await axios.post('/auth/reactivate', form)
        const token = res?.data?.data?.token
        if (token) {
          await this.$cookie.setCookie("token", token);
          await this.$store.commit("setToken", token);

          const profile = this.$store.getters.getProfile;
          if (profile) {
            await this.$store.commit("setDocumentHighlight", true);
            setTimeout(() => {
              this.$store.commit("setDocumentHighlight", false);
            }, 10000);
          }

          this.$cookie.setCookie("number", res?.data?.data.phone_number || this.phone);

          // NOTE: redirect akan happen, tapi kita tetap set loading false biar aman
          await this.$router.push("/dashboard");
          this.$store.commit("showGlobalAlert", {
            type: 'success',
            message: 'Akun berhasil diaktifkan',
            duration: 3000,
            position: "top-center",
          });
        }
      } catch (err) {
        console.error(err)
        this.$store.commit("showGlobalAlert", {
          type: 'danger',
          message: 'Terjadi Kesalahan',
          duration: 3000,
          position: "top-center",
        });
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.bh-modal {
  position: fixed;
  inset: 0;
  z-index: 99999;
}

.bh-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
}

.bh-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(520px, calc(100% - 32px));
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.25);
  overflow: hidden;
}

/* Banner */
.vp-banner {
  padding: 20px;
}
.vp-banner img {
  width: 100%;
  display: block;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
}

/* Content */
.vp-content {
  padding: 0px 20px 20px 20px;
  text-align: center;
}

.vp-title {
  font-size: 18px;
  font-weight: 800;
  color: #374151;
  margin-bottom: 10px;
}

.vp-desc {
  font-size: 13px;
  margin-bottom: 20px;
  margin-left: 2px;
  margin-right: 2px;
  line-height: 1.2;
}

/* Buttons */
.vp-btn-primary {
  width: 100%;
  background: #223f80;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px;
  font-weight: 700;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.vp-btn-primary:hover {
  background: #243d80;
}

.vp-btn-secondary {
  width: 100%;
  background: #fff;
  color: #2f4ea2;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  padding: 12px;
  font-weight: 700;
  cursor: pointer;
}

.loader {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.vp-btn-primary:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.7;
}

.vp-btn-primary:disabled:hover {
  background: #9ca3af;
}
</style>
